import React from "react";
import { useParams, useNavigate } from "react-router-dom";

import routes from "constants/routes";
import { mapCouponToFormValues } from "utils/couponUtils";
import { mapCouponInfoFromApi } from "helpers/couponApi";
import { formatApiErrorForDisplay } from "helpers/packageManagementApi";
import { useCouponInfo } from "store/backend/apiHooks";
import Loader from "shared/Loader/Loader";

import CouponForm from "./CouponForm";
import styles from "./CouponsList.module.scss";

const ViewCoupon = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data, isLoading, isError, error } = useCouponInfo(id);

  if (isLoading) {
    return (
      <div className={styles.emptyState}>
        <Loader />
      </div>
    );
  }

  if (isError || !data) {
    return (
      <div className={styles.emptyState}>
        <p>{formatApiErrorForDisplay(error, "Failed to load coupon details.")}</p>
        <button
          type="button"
          className={styles.createButton}
          onClick={() => navigate(routes.coupons.list)}
        >
          Back to Coupons
        </button>
      </div>
    );
  }

  const initialValues = mapCouponToFormValues(mapCouponInfoFromApi(data));

  return <CouponForm mode="view" initialValues={initialValues} />;
};

export default ViewCoupon;
